import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mb="20px" column justifyStart>
          <CFView h2 futura bold color="#FF9F00" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center white bold>
            {/* <CFLink href="https://www.facebook.com/victoriachimac/">
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Togo Sushi Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/chimac-korean-pub-and-fried-chicken-victoria-2">
              <CFImage w="45px" pr="10px" src={yelp} alt="Togo Sushi Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="45px"
                pr="10px"
                src={zomato}
                alt="Togo Sushi Zomato"
              />
            </CFLink> */}
            <CFLink href="https://www.instagram.com/togosushi_restaurant/?hl=en">
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Togo Sushi Instagram"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h2 futura bold color="#FF9F00" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter white bold>
            {/* <CFLink href="https://www.facebook.com/victoriachimac/">
              <CFImage
                w="40px"
                pr="10px"
                src={facebook}
                alt="Togo Sushi Facebook"
              />
            </CFLink>
            <CFLink href="https://www.yelp.ca/biz/chimac-korean-pub-and-fried-chicken-victoria-2">
              <CFImage w="40px" pr="10px" src={yelp} alt="Togo Sushi Yelp" />
            </CFLink>
            <CFLink href="https://www.zomato.com/victoria-bc/chimac-korean-pub-and-fried-chicken-victoria-city-of-victoria">
              <CFImage
                w="40px"
                pr="10px"
                src={zomato}
                alt="Togo Sushi Zomato"
              />
            </CFLink> */}
            <CFLink
              href="https://www.instagram.com/togosushi_restaurant/?hl=en"
              newTab
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Togo Sushi Instagram"
                hover
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
